exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip[data-v-3a98d9bc]{-webkit-line-clamp:1;line-clamp:1;white-space:nowrap;width:100%}.tooltip[data-v-3a98d9bc],.tooltip .child[data-v-3a98d9bc]{overflow:hidden;text-overflow:ellipsis}.tooltip .child[data-v-3a98d9bc]{width:inherit}", ""]);

// exports
